import { client } from '../client';
import { ITags } from './listAllTags';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const getTagsByUserId = async (user_id: number, userRole?: string): Promise<ITags[]> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/users/${user_id}/tags`);

  return data;
};
